//@flow
import React from 'react';
import QuoteApi from '../../APIInterfaces/quotes';
import UrlData from '../../Utils/url-data';
import { isDiscountNotApplicable as isS2SNotApplicable } from '../../Utils/sub2save';

import type QuoteTotalsModel from '../../Stores/Quote/quoteTotalsModel';
import type QuoteModel from '../../Stores/Quote/quoteModel';

type Props = {
  quoteTotals:QuoteTotalsModel,
  showInput?:boolean,
  quote:QuoteModel,
  showPromoCodePrompt?:boolean,
  showGiftUI:boolean,
};

type State = {
  code:string,
  showInput:boolean,
  hide:boolean,
  showPromoCodePrompt:boolean,
  promoCodeError:boolean,
};

export default class PromoCode extends React.Component<Props, State> {
  constructor(props:Props) {
    super(props);

    this.state = {
      code: '',
      showInput: props.showInput || false,
      hide: !!UrlData.getPromoCode(),
      showPromoCodePrompt: props.showPromoCodePrompt || false,
      promoCodeError: false,
    };
  }

  setPromoState = () => {
    this.setState({ showPromoCodePrompt: false });
  }

  applyPromoCode = () => {
    if (this.canSubmit()) {
      // remove quotes "" and blank space if added.
      const code = this.state.code.replace(/["\s]/g, '');
      const quoteId = this.props.quote.getId();
      if (quoteId) {
        QuoteApi.setPromoCode(quoteId, code)
          .onFailure(() => this.setState({ promoCodeError: true }));
      }
    }
  };

  promoCodeIsApplied():boolean {
    const appliedDiscount = this.props.quoteTotals.getAppliedDiscount();
    return !!appliedDiscount;
  }

  removePromoCode = () => {
    const quoteId = this.props.quote.getId();
    if (quoteId) QuoteApi.setPromoCode(quoteId, '');
  };

  canSubmit():boolean {
    return this.state.code.length > 0;
  }

  getBtnClassName():string {
    let className = 'promo-code-btn cta';
    if (!this.canSubmit()) className += ' inactive';
    return className;
  }

  showInput = () => {
    this.setState({
      showInput: true,
    });
  };

  updateCode = (event:SyntheticInputEvent<HTMLInputElement>) => {
    this.setState({
      code: event.currentTarget.value,
    });
  };

  renderApplyText() {
    if (this.state.showInput || this.promoCodeIsApplied()) return null;

    return (
      <span
        className="link-small promo-code-apply-text"
        onClick={this.showInput}
      >
        Apply
      </span>
    );
  }

  renderError() {
    if (this.state.promoCodeError) {
      return <div className="promo-code-error">Invalid promo code</div>;
    }
  }

  renderInput() {
    if (!this.state.showInput || this.promoCodeIsApplied()) return null;
    return (
      <div>
        <input
          className="promo-code-input"
          name="promo-code"
          placeholder="Promo code"
          onChange={this.updateCode}
          value={this.state.code}
          title="Promo code"
          type="text"
        />
        <span
          className={this.getBtnClassName()}
          onClick={this.applyPromoCode}
        >
          Apply
        </span>
      </div>
    );
  }

  renderPromoInfo() {
    if (!this.promoCodeIsApplied()) return null;
    const appliedDiscount = this.props.quoteTotals.getAppliedDiscount();
    const name = appliedDiscount && appliedDiscount.name;

    return (
      <div className="promo-code-info">
        <span className="promo-code-name">{name}</span>
        <span
          className="link-small promo-code-remove"
          onClick={this.removePromoCode}
        >
          Remove
        </span>
      </div>
    );
  }

  renderHeader() {
    if (!this.state.showInput) {
      return (<span className="promo-code-header" onClick={this.showInput}>Promo code</span>);
    }
  }

  renderDisclaimer() {
    if (this.props.showGiftUI) return (
      <div className="disclaimer">Most promo codes can&apos;t be applied to gifts</div>
    );
  }

  render() {
    const s2sNotApplicable = isS2SNotApplicable(
      this.props.quote, this.props.quoteTotals);

    if (this.state.hide || this.props.quote.isVirtual() || s2sNotApplicable) return null;

    if (this.state.showPromoCodePrompt && !this.promoCodeIsApplied() ) {
      return (
        <div className="promo-toggle" onClick={this.setPromoState}>
          Have a promo code?
        </div>
      );
    }

    return (
      <div className="promo-code text-2">
        <div>
          {this.renderHeader()}
          {this.renderApplyText()}
        </div>
        {this.renderInput()}
        {this.renderPromoInfo()}
        {this.renderDisclaimer()}
        {this.renderError()}
      </div>
    );
  }
}
